export const environment = {
  production: false,

  // Api config
  baseUrl: 'https://apa-staging.sprintax.com/',
  updateBaseUrl: 'https://apa-staging.sprintax.com/',
  apiVersion: 1,

  // Needed for BE testing purposes - to show/hide the "Swap Base URL" field in the header
  canSwapBaseUrl: false,

  // IS Config
  redirectUrl: 'https://login-staging-is.sprintax.com',
  oauthServerUrl: 'https://login-staging-is.sprintax.com',
  oauthRedirectUrl: 'https://aupair-staging.sprintax.com',
  isUserSettings: 'https://accounts-staging-is.sprintax.com/sign-in',
  requireHttps: true,

  auPairURLS: {
    2025: 'https://aupair-staging.sprintax.com/2025/',
    2026: 'https://aupair-staging.sprintax.com/2026/',
  } as Record<number, string>,
};
